// Import packages
import React, {Component} from "react";
import {connect} from "react-redux";

// Import components
import ItemsList from "../../components/ItemsList";
import PageWrapper from "../../components/pageContentViews/pageWrapper";
import PageHeader from "../../components/pageContentViews/pageHeader";

// Import utils
import {mapStateToProps} from "../../redux/mapStateToProps";
import {deleteItem} from "../../utils/helperFunctions";
import {
    GetBlogs, DeleteBlog
} from "../../redux/actions";
import {generateImageMediaUrl} from "../../utils/generateMemberMediaUrl";


class Blogs extends Component {
    componentDidMount() {
        this.props.GetBlogs();
    }

    render() {
        let {blogs, mainLanguage, requestLoading} = this.props;
        // console.log(blogs);
        let itemListHeaderInfo = {
            generalInfo: ["Նկար", "Անվանում", ],
            largeItems: [1],
            status: true,
            actions: ["edit", "delete"],
        };
        let itemListInfo = blogs.itemsList?.map((blog) => {
            const {id, title, mediaMain, isHidden} = blog;
            return {
                id,
                values: [
                    {
                        title: <img src={generateImageMediaUrl(mediaMain?.path)}/>
                    },
                    title ?? '-',
                ],
                status: !isHidden,
                deleteCb: deleteItem.bind(this, this.props.DeleteBlog, 'բլոգը', id)
            }
        });
        return <PageWrapper pageTitle={'Բլոգ'}>
            <PageHeader linkTitle={"Ավելացնել"}
                        addingLink={"/blogs/add"}/>
            <ItemsList itemListHeaderInfo={itemListHeaderInfo}
                       itemListInfo={itemListInfo}
                       loading={requestLoading}
                       editLink={"/blogs/edit"}/>
        </PageWrapper>
    }
}

const mapDispatchToProps = {
    GetBlogs,
    DeleteBlog,
};

export default connect(mapStateToProps, mapDispatchToProps)(Blogs);
